import { TriggerKeysType } from "@/app_redux/reducers/trigger_reducer";
import { useTriggers } from "./useTriggers";

export const useTriggerState = (triggerId: TriggerKeysType) => {
  const { getData, getStatus } = useTriggers(triggerId);
  return { data: getData(), status: getStatus() };
};
